import { render } from "./createUserLocation.vue?vue&type=template&id=6ef3f23c"
import script from "./createUserLocation.vue?vue&type=script&lang=js"
export * from "./createUserLocation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__